export default __webpack_public_path__ + "3e50e269ee627bb2279f91d18c085167.woff2";